import { getTelegramBotUsername } from 'shared/consts/telegram';

export const validateSetupManagementLink = (
  value: unknown
): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const botUsername = getTelegramBotUsername();
  if (!botUsername) return undefined;

  try {
    const url = new URL(value);
    const payload = url.searchParams.get('start');
    const parameters = Array.from(url.searchParams.keys());
    if (
      url.protocol !== 'https:' ||
      url.hostname !== 't.me' ||
      url.port ||
      url.username ||
      url.password ||
      url.hash ||
      url.pathname.toLowerCase() !== `/${botUsername.toLowerCase()}` ||
      parameters.length !== 1 ||
      parameters[0] !== 'start' ||
      !payload ||
      !/^bind_[A-Za-z0-9_-]{1,59}$/.test(payload)
    )
      return undefined;

    return `https://t.me/${botUsername}?start=${payload}`;
  } catch {
    return undefined;
  }
};
